import { useQuery } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { ExtractFnReturnType, QueryConfig } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

const url = `${PREFIX_URL}/library/:sourceId/document/comments`;

export type GetLibraryItemCommentsResponse = {
  status: boolean;
  data: any;
};

export type GetLibraryItemCommentsDTO = {
  sourceId: number;
};

export type GetLibraryItemCommentsParams = {
  page: number;
  inTrash?: boolean;
  limit: number;
};

export const getLibraryItemCommentsQueryKey = {
  all: ['getLibraryItemComments'] as const,
  list: (sourceId) => [...getLibraryItemCommentsQueryKey.all, sourceId] as const,
};

export const getLibraryItemComments = ({
  sourceId,
}: GetLibraryItemCommentsDTO): Promise<GetLibraryItemCommentsResponse> => {
  const URL = generateRoutePath(url, { sourceId });

  return axios.get(URL);
};
type QueryFnType = typeof getLibraryItemComments;

type UseGetLibraryItemCommentsOptions = {
  sourceId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetLibraryItemComments = ({
  sourceId,
  config,
}: UseGetLibraryItemCommentsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: [...getLibraryItemCommentsQueryKey.all, sourceId],
    queryFn: () => getLibraryItemComments({ sourceId }),
    // staleTime: Infinity,
    cacheTime: 0,
    ...config,
  });
};
